import React from 'react'
import './footer.css'
import Logo from '../Logo/Logo'
export default function Footer() {
    return (
    <footer class="footer-bs">
        <div class="row">
        	<div class="col-md-3 footer-brand animated fadeInLeft">
                <Logo/>
                <p>© 2021 Bank of Bosse, All rights reserved</p>
            </div>
        	<div class="col-md-5 footer-nav animated fadeInUp">
            	<h4>Menu —</h4>
            	<div class="col-md-12">
                    <ul class="pages">
                        
                    <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/cyber-security-policy">Cyber Security Policy</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/bcp-or-diaster-recovery-plan">BCP or Diaster-Recovery Plan</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/vq-point-privacy-policy">Privacy Policy</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/vq-point-terms-of-service">Terms of Service</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/vq-point-return-policy">Return Policy</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/vq-point-disclaimer">Disclaimer</a></li>
                        <li><a target="_blank" rel="noopener noreferrer" href="https://www.xembx.com/vq-point-cookie-policy">Cookie Policy</a></li>
                    </ul>
                </div>
            </div>
        	<div class="col-md-4 footer-social animated fadeInDown">
            	<h4>Follow Us</h4>
            	<ul>
                	<li><a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/vain.queur.71">Facebook</a></li>
                	<li><a target="_blank" rel="noopener noreferrer" href="https://twitter.com/vainqueurco">Twitter</a></li>
                	<li><a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/vainqueurco/">Instagram</a></li>
                	{/* <li><a href="#">RSS</a></li> */}
                	<li><a href="tel:4044842014">Call Us Now 4044842014</a></li>

                </ul>
            </div>
        </div>
    </footer>
    )
}
